module.exports = __webpack_public_path__ + "img/user-11.871b0080.png";